// Теги, включающие кнопку «Запрос на отмену Wolt» на аптеке (source)
// или на сети (network). Разные id для дев- и прод-окружения.
const IS_DEV_AREA = Boolean(process.env.REACT_APP_DEV_AREA);
export const WOLT_CANCEL_SOURCE_TAG_ID = IS_DEV_AREA ? 1053 : 1197;
export const WOLT_CANCEL_NETWORK_TAG_ID = IS_DEV_AREA ? 1054 : 1198;

// Аптечный статус, который проставляется при запросе отмены
export const WOLT_CANCEL_REQUESTED_STATUS = 'wolt_cancel_requested';

// Bridge-сервис отмены Wolt-заказов
export const WOLT_CANCEL_BRIDGE_URL =
  'https://densertech-production.up.railway.app/api/cancellation-request';

// Время отправки запроса храним локально: бэк отдаёт только статус заказа,
// без отметки времени. Записи старше 30 дней чистим при следующей записи.
export const WOLT_CANCEL_SENT_AT_KEY = 'woltCancelSentAt';
export const WOLT_CANCEL_SENT_AT_TTL_MS = 30 * 24 * 60 * 60 * 1000;

// Причины отмены. value уходит в cancellationReason как есть (контракт bridge),
// labelKey — подпись в интерфейсе из OrderPage.WoltCancel.Reasons
export const WOLT_CANCEL_REASONS: { value: string; labelKey: string }[] = [
  { value: 'Нет в наличии всего заказа', labelKey: 'OUT_OF_STOCK_FULL' },
  { value: 'Истекший срок годности', labelKey: 'EXPIRED' },
  { value: 'Срок годности, подходящий к концу', labelKey: 'EXPIRING_SOON' },
  { value: 'Технические проблемы в аптеке', labelKey: 'TECHNICAL_ISSUES' },
  { value: 'Клиент отказался', labelKey: 'CLIENT_REFUSED' },
];
